import { render } from "./PPEDashboard.vue?vue&type=template&id=1697b88e"
import script from "./PPEDashboard.vue?vue&type=script&lang=js"
export * from "./PPEDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__